import React from "react";
import Header from "./layout/Header/Header";

/**
 * Menu de botones en formato tarjeta, estilo Admin, agrupado por secciones.
 *
 * Uso:
 *   <MenuBotones
 *     titulo="Compras"
 *     descripcion="Ordenes de compra, embarques y recepciones"
 *     icono="fas fa-shopping-cart"
 *     color="#3b82f6"
 *     secciones={[
 *       { section: "Ordenes", items: [
 *           { label: "Ordenes de Compra", icon: "fas fa-file-invoice",
 *             color: "#3b82f6", href: "/ListadoOrdenesCompra", desc: "...", enabled: !!user.menu_oc },
 *       ]},
 *     ]}
 *   />
 *
 * Si un item no trae `enabled`, se asume habilitado.
 * Las secciones sin items visibles no se pintan.
 */
function MenuBotones({ titulo, descripcion, icono = "fas fa-th-large", color = "#3b82f6", secciones = [] }) {
  const tono = (c) => `${c}14`; // mismo color con alpha, para el fondo del icono

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "20px 24px" }}>

        {/* Encabezado del menu */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 22 }}>
          <div
            style={{
              width: 36, height: 36, borderRadius: 8, background: tono(color),
              display: "flex", alignItems: "center", justifyContent: "center",
              border: `1px solid ${color}40`,
            }}
          >
            <i className={icono} style={{ color, fontSize: "0.95rem" }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
              {titulo}
            </h3>
            {descripcion ? (
              <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>{descripcion}</p>
            ) : null}
          </div>
        </div>

        {secciones.map((sec, si) => {
          const items = (sec.items || []).filter((i) => i && i.enabled !== false);
          if (items.length === 0) return null;

          return (
            <div key={si} style={{ marginBottom: 18 }}>
              {sec.section ? (
                <div
                  style={{
                    fontSize: "0.66rem", fontWeight: 700, textTransform: "uppercase",
                    letterSpacing: "0.09em", color: "#94a3b8",
                    padding: "0 0 8px 2px", borderBottom: "1px solid #e2e8f0",
                    marginBottom: 14,
                  }}
                >
                  {sec.section}
                </div>
              ) : null}

              <div className="row">
                {items.map((r, i) => (
                  <div key={i} className="col-6 col-md-4 col-xl-3 mb-3">
                    <a
                      href={r.href}
                      style={{
                        display: "flex", flexDirection: "column", alignItems: "center",
                        gap: 10, padding: "22px 14px", background: "#fff",
                        borderRadius: 10, boxShadow: "0 1px 3px rgba(0,0,0,0.07)",
                        border: "1px solid #f1f5f9", textDecoration: "none",
                        color: "#334155", textAlign: "center", height: "100%",
                        transition: "box-shadow 0.15s, transform 0.15s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
                        e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)";
                        e.currentTarget.style.transform = "none";
                      }}
                    >
                      <div
                        style={{
                          width: 46, height: 46, borderRadius: 12,
                          background: tono(r.color || color),
                          display: "flex", alignItems: "center", justifyContent: "center",
                        }}
                      >
                        <i className={r.icon || icono} style={{ color: r.color || color, fontSize: "1.15rem" }} />
                      </div>
                      <div style={{ fontSize: "0.82rem", fontWeight: 600, lineHeight: 1.25 }}>
                        {r.label}
                      </div>
                      {r.desc ? (
                        <div style={{ fontSize: "0.68rem", color: "#94a3b8", lineHeight: 1.3 }}>
                          {r.desc}
                        </div>
                      ) : null}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default MenuBotones;
